"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.breakpoints = void 0;
exports.breakpoints = {
    grid: {
        breakpointSm: '320px',
        breakpointMd: '600px',
        breakpointLg: '1280px',
        breakpointXl: '1328px',
        breakpoint2xl: '1920px',
    },
};
//# sourceMappingURL=breakpoints.js.map